import { render, staticRenderFns } from "./ManagementCertificates.vue?vue&type=template&id=e185f3c2&"
import script from "./ManagementCertificates.vue?vue&type=script&lang=js&"
export * from "./ManagementCertificates.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports